import { ApprovalStatusCodeEnum } from "./version-share.model";
import { FeedbackStatusCodeEnum } from "./version-share.model";



export interface ApprovalActionPayload {
    message: string;
    status: ApprovalStatusCodeEnum | FeedbackStatusCodeEnum;
    password?: string; // second call signature optional
    pin?: string; // second step call signature optional cfr11  
    email?: string; // second step call signature optional cfr11  

}
/**
 *  Error codes for the call response for approval
    @enum { number } 
    201 (ACCEPTED) if is ok (status updated)
    412 user has not password error
    422 (need other datas in payload)
 */
export enum ApprovalActionResponseCodeEnum {
    ACCEPTED_201 = 201,
    NO_PASSWORD = 412,
    MORE_DATA = 422,
    NOT_ACCEPTABLE = 406
}

/**
 * Status codes for the request new pin for approval
 * @enum { number } 
 */
export enum AprovalCfr11PinStatusCodeEnum {
    DEFAULT = 0,
    REQUESTED = 1,
    RENEWED = 2,
    ERROR = 3
}

/**
 *  {
        "signature": "(string)"
    }
    @enum { string } 
    "signature" types:
    - "default" -> need password
    - "cfr11-complete" -> need password and pin
    - "cfr11-short" -> need only password
 */
export enum ApprovalActionTypeEnum {
    DEFAULT = 'default',
    CFR11_COMPLETE = 'cfr11-complete',
    CFR11_SHORT = 'cfr11-short',
    CFR11_COMPLETE_EMAIL = 'cfr11-complete-email'
}
/**
 * Used in approval service to send the credentials on signature process.
 */
export interface ApprovalSignatureCredentials {
    password?: string; // call signature optional
    pin?: string; // second step call signature optional cfr11  
    email?: string; // second step call signature optional cfr11  
}
  

export interface ApprovalActionResponse {
    signature: ApprovalActionTypeEnum;
}